
export const GET_USER_PROFILE_SUCCESS = "GET_USER_PROFILE_SUCCESS";
export const GET_NOTIFICATION_SUCCESS = "GET_NOTIFICATION_SUCCESS";
export const GET_CHAT_COUNTER_SUCCESS = "GET_CHAT_COUNTER_SUCCESS";
export const GET_TOTAL_NOTIFICATIONS_SUCCESS = "GET_TOTAL_NOTIFICATIONS_SUCCESS";

